'use client';

import { useStore } from 'features/store';
import type React from 'react';
import { PageAlerts } from '@/components/PageAlerts';
import { EmptyLayout } from '@/layouts/EmptyLayout';

export default function AuthPageLayout({ children }: React.PropsWithChildren) {
  const bannerHeight = useStore(({ LayoutStoreData: s }) => s.bannerHeight, []);

  return (
    <EmptyLayout style={{ paddingTop: bannerHeight }}>
      <EmptyLayout.Alerts>
        <PageAlerts hideTosUpdateBanner />
      </EmptyLayout.Alerts>
      {children}
    </EmptyLayout>
  );
}
